import React from 'react';

const Product = () => {
  return (
    <div style={{ padding: '40px', textAlign: 'center', fontSize: '0.85rem' }}>
      Work in progress — contact Eryk with suggestions.
    </div>
  );
};

export default Product; 